module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"profile":{"description":{"action":"Add description","empty_state":"Add a description to your profile so that the community can get to know you better. For example, describe your investment strategies, the type of advice you offer or what is important to you.","title":"My investment philosophy"}}}}}}}')
  delete Component.options._Ctor
}
